<template>
    <v-app  id="inspire">
      <v-navigation-drawer
      v-model="drawer"
      app
      right
      
      color="#D8E2DC"
    >
      <v-list
        dense
        nav
      >
      <v-icon x-large @click="drawer=false">mdi-close</v-icon>
      <div style="height:30px"></div>

        <v-list-item @click="goTOWebsite()">
          <v-list-item-icon>
            <v-icon x-large color= '#0D1231'>mdi-information-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content >
            <v-list-item-title style="font-size:1.2rem;color:'#0D1231'">אודות הקרן</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div style="height:30px"></div>
        <v-list-item @click="signOut()">
          <v-list-item-icon>
            <v-icon x-large color= '#0D1231'>mdi-exit-to-app</v-icon>
          </v-list-item-icon>

          <v-list-item-content >
            <v-list-item-title style="font-size:1.2rem;color:'#0D1231'">התנתקות</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer> 
    <div class="d-flex align-center">
      <div class="cover2"> 
        <div class="logoforcover2"></div>
        <!-- <v-img width=1 src="../assets/logo4.png"></v-img> -->
      </div>
      <div style="position: absolute;margin-right:1rem">
        <v-btn icon @click="drawer=true">
          <v-icon  color="white">mdi-menu</v-icon>
        </v-btn>
      </div>
    </div>

    <v-main style="background-color:#FAFAFA">
       <div class="mainContainer">
              <v-row no-gutters justify="center" style="margin-top:2rem;margin-bottom:2rem">
                 <v-col cols="12" md="4" sm="12">
                   <v-card  min-height="20vh" width="100%" color="white" style="">
                      <v-col style="direction:rtl;text-align:center;">
                    <h2 style="margin-top:1rem;margin-bottom:2rem">שלום, {{userName}}</h2>
                    <h4 style="color:#01579B;"> תאריך עדכון אחרון: {{lastUpdate}}</h4>
              
                 </v-col>
                   </v-card>
                 </v-col>
              </v-row>
              <v-row no-gutters justify="center">
                 <v-col cols="12" md="4" sm="12">
                  <div v-for="item in funds" :key="JSON.stringify(item)">
                  <v-card   style="margin-bottom: 10px;display: flex;align-items: center;" min-height="30vh">
                    <v-chip  v-if="item.fundTag != ''" class="tag" color="amber">{{item.fundTag}}</v-chip>
                    <v-col>
                      <v-row>
                        <v-col style="direction:rtl;text-align:center;">
                          <h2>{{item.fundName}}</h2>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col style="direction:rtl;text-align:center;">
                          <h3 style="color:#01579B">יתרה משוערכת</h3>

                          <h1 v-if="getFundCurrency(item.fund) == '$'" style="color:#01579B">{{numberWithCommas(item.money.toFixed(0))}}<span style="margin-left:5px">{{getFundCurrency(item.fund)}}</span></h1>
                          <h1 v-else style="color:#01579B"> {{numberWithCommas(item.money.toFixed(0))}} {{getFundCurrency(item.fund)}}</h1>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                 </div>
                 </v-col>
              </v-row>
              <v-row justify="center">
              <v-col cols="12" md="4" sm="12">
                <h6 style="text-align: center;margin-top:5px;padding:5px">
 הערך הכספי המוצג כיתרה משוערכת אינו מבוקר ע״י האדמיניסטרטור ומהווה הערכה בלבד ע״י מנהל הקרן לשווי הכספים נכון לתאריך השערוך. היתרה המוצגת הינה ברוטו , לאחר עמלות ולפני מיסים שנוכו.
              </h6>  
          </v-col></v-row>      
        </div>
    </v-main>
  </v-app>
</template>

<script>
import {db}  from '../firebase';
import {auth}  from '../firebase';
import moment from 'moment';

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    funds:[],
    drawer:false,
    fundsList :[],
    userName :'',
    lastUpdate : '',
  }),

  methods:{
    async getFunds(){
      this.funds = []
      let data = this;
      let docs  =  await db.collection('Customers').doc(this.$store.state.user.uid).collection('FundsData').get();
      docs.forEach(doc=>{
        let docData = doc.data();
        docData['fundName'] = (docData.fund.split('-'))[0];
        docData['fundTag'] = (docData.fund.split('-'))[1];
        if(!docData.fundTag){
          docData['fundTag'] = ''
        }
        data.funds.push(docData);
      })
    },
    signOut(){
      auth.signOut()
    },
    goTOWebsite(){
      location.replace('https://www.adiver-capital.com/')
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getFundCurrency(fundName){
      let options =  this.fundsList.filter(item=>{
        return fundName == item.id;
      })

      if(options.length>0){
        return options[0].currency
      }else{
        return ''
      }
    }
  },

  async mounted(){
   
    let docs =  await db.collection('Funds').get();
    docs.forEach(doc=>{
      this.fundsList.push(doc.data());
    });
    this.userName = (this.$store.state.user.displayName)
    let userObj =  await db.collection('Customers').doc(this.$store.state.user.uid).get();
     userObj = userObj.data()
     console.log()
     this.lastUpdate = moment(userObj.lastUpdate.toDate()).format('DD/MM/YYYY')


      this.getFunds();
  }
};
</script>
<style scoped>
  .mainContainer{
    padding:1rem;
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif ;
  }
  .tag{
    margin-right: 10px;
    margin-top: 10px;
    font-weight: bold;
  }
 
  .cover2{
    width:100vw;height:140px;
    background-repeat: no-repeat;
    background-size: 100vw 250px;
    background-position-x: 50%;
    background-position-y: 50%;
    position: relative;
          background-color: #0D1231;

  }
  .logoforcover2{
      background-image: url('../assets/logo4.png');
      width:300px;height:110px;
      background-size: 200px 100px;
      background-position-x: 50%;
      background-position-y: 50%;
      background-repeat: no-repeat;
      position: absolute;
      left: calc(50% - 150px);
      top:calc(12%);
  }
</style>